import type { QuestionnaireSummaryCta } from "@ferrivia/api-contract";
import { useTranslation } from "@ferrivia/i18n";
import { CtaButton } from "./CtaButton";
import s from "./NextSteps.module.css";

export interface NextStepsProps {
  path: QuestionnaireSummaryCta;
  onOpenBooking: () => void;
}

function useCtaLabel(path: QuestionnaireSummaryCta) {
  const { t } = useTranslation("client");
  return path === "infusion"
    ? t("summary.nextSteps.infusion.button", "Varaa etävastaanottoaika")
    : t("summary.nextSteps.support.button", "Varaa aika läpikäyntipuheluun");
}

export function StickyCta({ path, onOpenBooking }: NextStepsProps) {
  const label = useCtaLabel(path);

  return (
    <div className={s.sticky}>
      <CtaButton path={path} onOpenBooking={onOpenBooking}>
        {label}
      </CtaButton>
    </div>
  );
}
